import { defineStore } from 'pinia';
import Network from "~/utils/network";
import { useB2bFlowStore } from './b2bFlow';
import { useCartStore } from './cart';


const urls = {
  createPrescore: `/bnpl/pre-score/b2b`, // POST
  sendSuccessEmail: (publicId) => `/bnpl/pre-score/successful_email/${publicId}`, // POST
  getOffer: (offerId) => `/bnpl/external/offer/${offerId}`, // GET
};

/**
 * BNPL Application store
*/

export const useB2bPrescoreStore = defineStore('b2bPrescore', {
  state: () => {
    return {
      offerId: null,
      redirectUrl: '',
      merchantId: null,
      offer: {}
    };
  },
  actions: {
    createPrescore: async function () {
      const b2bFlowStore = useB2bFlowStore();
      const cartStore = useCartStore();
      try {
        let data = await Network.http(urls.createPrescore, {
          method: 'POST',
          body: {
            offerId: this.offerId,
            merchantId: this.merchantId,
            totalAmount: cartStore.cart.sum,
            financier: b2bFlowStore.financier,
            redirectUrl: this.redirectUrl,
            itemName: cartStore.cart.name,
            itemDescription: cartStore.cart.description
          }
        });
        b2bFlowStore.publicId = data.publicId;
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    getOffer: async function (offerId) {
      try {
        let data = await Network.http(urls.getOffer(offerId), {
          method: 'GET',
        });
        this.offer = data;
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    sendSuccessEmail: async function () {
      const b2bFlowStore = useB2bFlowStore();
      try {
        await Network.http(urls.sendSuccessEmail(b2bFlowStore.publicId), {
          method: 'POST'
        });
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
  },
  getters: {
    getActiveOffer: function () {
      return this.selectedOffer;
    },
  },
}
);
